import * as REGIONS from './regions';

export const ENERGY_USAGE_PERIOD_CODES = {
  '08': {
    value: '08',
    label: 'Bi-monthly',
    annualCoefficient: 6,
  },
  '04': {
    value: '04',
    label: 'Monthly',
    annualCoefficient: 12,
  },
  '05': {
    value: '05',
    label: 'Quarterly',
    annualCoefficient: 4,
  },
  '07': {
    value: '07',
    label: 'Yearly',
    annualCoefficient: 1,
  },
};

export const ENERGY_USAGE = (region) => ({
  electricity: {
    energyUnitAbbr: 'kWh',
    energyUnit: 'Kilowatts per hour',
    placeholder: '',
    label: 'Electricity',
    usagePeriods: [ENERGY_USAGE_PERIOD_CODES['04'], ENERGY_USAGE_PERIOD_CODES['05']],
    maxLength: 4,
  },
  gas: {
    energyUnitAbbr: `${region === REGIONS.WA.id ? 'Units' : 'MJ'}`,
    energyUnit: `${region === REGIONS.WA.id ? 'Units' : 'Megajoules'}`,
    placeholder: '',
    label: 'Gas',
    usagePeriods: [ENERGY_USAGE_PERIOD_CODES['08'], ENERGY_USAGE_PERIOD_CODES['05']],
    maxLength: 5,
  },
});

export const FUEL_MAPPING = {
  electricity: 'electricity',
  gas: 'natural gas',
};
